import { createBrowserHistory } from "history";
export const axHistory = createBrowserHistory();
